declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbAddConsumptiongroupModal } from './modal/addconsumptiongroup.modal';
import { NgbEditConsumptiongroupModal } from './modal/editconsumptiongroup.modal';
import { CustomCodeValuesController, ConsumptionGroupItemsController, ConsumptionGroupItemsRequest, MaterialSpecsController, MaterialSpecsRequest, SaveConsumptionGroupItemRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { CustomCodeTypeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { NgbAddGroupItemModal } from './modal/addgroupitem.modal';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { MaterialSpecpipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { ConsumpationData } from '../_MasterClasses/MaterailClasses';







@Component({
  selector: 'materialconsumption',
  templateUrl: './materialconsumption.component.html',
  styleUrls: [
    './materialconsumption.component.scss']
  , animations: [routerTransition()]
})

export class MaterialConsumptionComponent implements OnInit {


  public ShowList: boolean = true;
  public ShowList2: boolean = false;
  public ShowList3: boolean = false;
  public AddFeature: boolean = false;
  public EditFeature: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  //public searchText: any;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  isMatListLoading: boolean = false;

  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService,
    private filter: MaterialSpecpipe,
    private tosterservice: NGXToastrService,
    /*public CUstomDataByRequestTypeService: CUstomDataByRequestTypeService*/) { }


  CurrentSaveConsumptionGroupItemRequest: SaveConsumptionGroupItemRequest;

  ngOnInit() {    
    this.LoadGroups();
    this.LoadItems();
    this.CurrentSaveConsumptionGroupItemRequest = new SaveConsumptionGroupItemRequest();
    this.CurrentSaveConsumptionGroupItemRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  SelectedFeatures() {
    this.ShowList = true;
    this.ShowList2 = true;
    this.ShowList3 = true;
    this.AddFeature = false;
    this.EditFeature = false;
  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  //RequestedTypeValueByType(): void {
  //  this.StartRefreshing();

  //  this.CUstomDataByRequestTypeService.GetCustomDataByRequestedType(this.CurrentCustomCodeTypeRequest).subscribe
  //    (
  //      (result) => {


  //        this.ApiResData = result;
  //        if (!this.ApiResData.hasError) {
  //          this.CurrentCustomCodeValuesController = this.ApiResData.Result;

  //          this.stopRefreshing();

  //        }
  //        else {
  //          this.stopRefreshing();
  //          if (this.ApiResData.ErrorData != "") {
  //            alert(this.ApiResData.ErrorData);
  //          }
  //          else {
  //            alert(' Failed Due to Internal Error.... Please Contact Admin..');
  //          }
  //        }


  //      },

  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alert(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alert(error);


  //          this.stopRefreshing();
  //        }
  //      }
  //    );;

  //}

  CurrentCustomCodeValuesController: CustomCodeValuesController[];
  CurrentCustomCodeTypeRequest: CustomCodeTypeRequest;

  LoadGroups() {
    this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
    this.CurrentCustomCodeTypeRequest.RequestedType = "Consumption Groups";
    this.CurrentCustomCodeTypeRequest.FacilityCode = 0;
    this.CurrentCustomCodeTypeRequest.ActorCode = 0;
    this.CurrentCustomCodeTypeRequest.CustomCode = 0;
    this.CurrentCustomCodeTypeRequest.CustomType = '';
    this.CurrentCustomCodeTypeRequest.StringContains = '';
    this.CurrentCustomCodeTypeRequest.MedicineCode = 0;
    this.CurrentCustomCodeTypeRequest.CodeType = '';
    this.CurrentCustomCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCustomCodeValuesController();
  }
  GetCustomCodeValuesController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.actorservice.GetCustomCodeValuesController(this.CurrentCustomCodeTypeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCustomCodeValuesController = this.ApiResData.Result;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentMaterialSpecsController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentMaterialSpecsController,
          this.listFilter);
      }
    }
  }

  CurrentMaterialSpecsController: MaterialSpecsController[];
  CurrentMaterialSpecsRequest: MaterialSpecsRequest;

  LoadItems() {

    this.CurrentMaterialSpecsRequest = new MaterialSpecsRequest();
    this.CurrentMaterialSpecsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentMaterialSpecsRequest.SearchText = "";
    this.pdata = this.CurrentMaterialSpecsController;
    this.GetMaterialSpecsController();
  }
  GetMaterialSpecsController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.actorservice.GetMaterialSpecsController(this.CurrentMaterialSpecsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentMaterialSpecsController = this.ApiResData.Result;
          this.pdata = this.CurrentMaterialSpecsController;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  SelectedGroupDetails: CustomCodeValuesController;

  SelectedGroup(objCategory: any) {
    var Items: CustomCodeValuesController = objCategory;
    if (Items != null) {
      this.SelectedGroupDetails = null;
      this.SelectedGroupDetails = Items;
      this.GroupItems();
    }

  }
  CurrentConsumptionGroupItemsRequest: ConsumptionGroupItemsRequest;
  CurrentConsumptionGroupItemsController: ConsumptionGroupItemsController[];
  GroupItems() {

    this.CurrentConsumptionGroupItemsRequest = new ConsumptionGroupItemsRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentConsumptionGroupItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentConsumptionGroupItemsRequest.ConditionalOperator = 10;
    this.CurrentConsumptionGroupItemsRequest.GroupCode = this.SelectedGroupDetails.Code;
    //this.CurrentConsumptionGroupItemsRequest = new Array<ServicesByCategoryCodeController>();

    this.GetConsumptionGroupItemsController();

  }
  GetConsumptionGroupItemsController() {
    this.StartRefreshing();
    if (this.CurrentConsumptionGroupItemsController != null) {
      this.CurrentConsumptionGroupItemsController.splice(0, this.CurrentConsumptionGroupItemsController.length);
    }
    this.actorservice.GetConsumptionGroupItemsController(this.CurrentConsumptionGroupItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentConsumptionGroupItemsController = this.ApiResData.Result;
          this.AddData();

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  CurrentConsumpationData: Array<ConsumpationData>;
  AddData() {

    //this.CurrentConsumpationData = this.CurrentConsumptionGroupItemsController;
    this.CurrentConsumpationData = new Array<ConsumpationData>();
    this.CurrentConsumptionGroupItemsController.forEach((v, i, d) => {
      var item = new ConsumpationData();
      item.ItemCode = v.ItemCode;
      item.ItemName = v.ItemName;
      item.MinQty = v.MinQty;
      item.MaxQty = v.MaxQty;
      item.Uom = v.Uom;
      item.GroupCode = v.GroupCode;
      item.GroupType = v.GroupType;
      item.GroupName = v.GroupName;
      this.CurrentConsumpationData.push(item);
    });
    //if (this.CurrentConsumpationData.length == 0) {
    //    this.del_();
    //}

  }

  //  CurrentItemDetails: Array<ItemDetails>;
  //AddRow(l: MaterialSpecsController) {

  //  this.newmodal2(l)


  //}

  //CurrentConsumptionGroupItemsController: ConsumptionGroupItemsController[];
  //CurrentConsumptionGroupItemsRequest: ConsumptionGroupItemsRequest;

  //LoadItems() {
  //  this.CurrentConsumptionGroupItemsRequest = new ConsumptionGroupItemsRequest();
  //  this.CurrentConsumptionGroupItemsRequest.GroupCode = 4;
  //  this.CurrentConsumptionGroupItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetConsumptionGroupItemsController();
  //}
  //GetConsumptionGroupItemsController() {
  //  this.StartRefreshing();

  //  this.actorservice.GetConsumptionGroupItemsController(this.CurrentConsumptionGroupItemsRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        this.CurrentConsumptionGroupItemsController = this.ApiResData.Result;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}

  newmodal1() {
    const modalRef = this.modalService.open(NgbAddConsumptiongroupModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false
      })
    //modalRef.result.then((val: string) => {
    //  this.LoadGroups();
    //});
    this.LoadGroups();
  }



  EditGroupItem(l: ConsumptionGroupItemsController) {

    const modalRef = this.modalService.open(NgbAddGroupItemModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    //modalRef.componentInstance.matSpec = l
    modalRef.componentInstance.isEdit = true
    modalRef.componentInstance.editGroupItem = l

  }

  newmodal2(l: CustomCodeValuesController) {

    const modalRef = this.modalService.open(NgbAddGroupItemModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.matSpec = l;
    modalRef.componentInstance.ConsumptionGroup = this.SelectedGroupDetails.Code;
    modalRef.result.then((val: string) => {
      this.GroupItems();
    });
  }
  EditFeat() {
    const modalRef = this.modalService.open(NgbEditConsumptiongroupModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
  }

}
//export class ItemDetails {
//  public ItemName: string;
//  public MinQty: number;
//  public MaxQty: number;
//  public Uom: string;
//  public RowNumber: number;
//  public GroupCode: number;
//  public GroupName: string;
//  public Edit: boolean;
//}
//export class ConsumpationData {

//  public GroupCode: number;
//  public GroupName: string;
//  public GroupType: string;
//  public ItemCode: number;
//  public ItemName: string;
//  public MinQty: number;
//  public MaxQty: number;
//  public Uom: string;
//}
